import React from "react";
import { useState, useRef } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { countries } from "country-data-list";
import * as service from "./service";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import CurrentPasswordModal from "../../../Components/Modals/CurrentPasswordModal";
import CancelSubscriptionModal from "../../../Components/Modals/CancelSubscriptionModal";
import PauseSubscriptionModal from "../../../Components/Modals/PauseSubscriptionModal";
import LogoutAllModal from "../../../Components/Modals/LogoutAllModal";
import { getUserDetails } from "../../../Redux/UserDetailsSlice/UserDetailsSlice";
import Loading from "../../../Components/Loading/Loading";
import Translate from "../../../Components/Multilanguage/Translate";
import { delay } from "../../../utils/utils";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { parsePhoneNumber } from 'libphonenumber-js';
import { resumeSubscription } from "./service";


const NewAccountSettings = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const selectedLanguage = useSelector((state) => state?.languageModal?.value?.selectedLanguage);
  const userDetails = useSelector((state) => state?.userDetails?.value);
  const userCoins = userDetails?.user_coins;  
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const [accountDetails, setAccountDetails] = useState({});
  const [countryListOption, setCountryListOption] = useState([]);
  const [values, setValues] = useState({});
  const [PasswordModal, setPasswordModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [cancelSubModal, setCancelSubModal] = useState(false);
  const [pauseSubModal, setPauseSubModal] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const [profileWill, setProfileWill] = useState()
  const [loading, setLoading] = useState(true)
  const [changedValue, setChangedValue] = useState({ email_sms_consent: true });
  const [activeSidebarTab, setActiveSidebarTab] = useState("profile");
  const [profileDirty, setProfileDirty] = useState(false);
  const [profileUploading, setProfileUploading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentCountry, setCurrentCountry] = useState({})
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(true);
  const profileSectionRef = useRef(null);
  const paymentSectionRef = useRef(null);
  const settingsSectionRef = useRef(null);
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const theme = projectInfo?.projectConfig?.config?.THEME;
  useEffect(() => {
    window.scroll(0, 0);
    fetchAccountDetails();
    // setCountryListOption(
    //   countries?.all?.map((item, index) => {
    //     const { alpha2, name } = item;
    //     return (
    //       <option key={index} value={alpha2}>
    //         {name}
    //       </option>
    //     );
    //   })
    // );
  }, []);
  useEffect(() => {
    if (accountDetails) {
      setCountryListOption(
        countries?.all?.map((item, index) => {
          const { alpha2, name } = item;
          if (item?.alpha2 !== accountDetails?.country_code) {
            return (
              <option key={index} value={alpha2}>
                {name}
              </option>
            );
          } else {
            setCurrentCountry({ name, value: alpha2 })
          }
        })
      );
    }
  }, [accountDetails])

  const handleResume = async () => {
    setLoading(true);
    try {
      const response = await resumeSubscription(appInfo, accountDetails?.sub_id);
      if (response?.status === 200) {
        toast.success(<Translate textKey={'subscription_resume'} />, {
          position: "bottom-center",
        });
        setPauseSubModal(false);
        fetchAccountDetails?.(true);
      } else {
        toast.error(response?.data?.message || "Failed to pause subscription.");
      }
    } catch (err) {
      toast.error(err.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const fetchAccountDetails = async (isUpdate) => {
    setLoading(true)
    try {
      isUpdate && await delay(3000);
      const accountDetailsResponse = await service.getAccountDetails(appInfo);
      if (accountDetailsResponse?.status === 200) {
        const currentValues = {
          email: accountDetailsResponse?.data?.data?.user_email,
          firstName: accountDetailsResponse?.data?.data?.first_name,
          lastName: accountDetailsResponse?.data?.data?.last_name,
          phone: accountDetailsResponse?.data?.data?.phone,
          country: accountDetailsResponse?.data?.data?.country_code,
          address1: accountDetailsResponse?.data?.data?.address1,
          address2: accountDetailsResponse?.data?.data?.address2,
          city: accountDetailsResponse?.data?.data?.city,
          state: accountDetailsResponse?.data?.data?.state,
          postal_code: accountDetailsResponse?.data?.data?.postal_code,
          celebrity_source: accountDetailsResponse?.data?.data?.celebrity_source,
          favorite_celebrity: accountDetailsResponse?.data?.data?.favorite_celebrity,
          birthday: accountDetailsResponse?.data?.data?.birthday,
          instagram: accountDetailsResponse?.data?.data?.instagram,
          youtube: accountDetailsResponse?.data?.data?.youtube,
          facebook: accountDetailsResponse?.data?.data?.facebook,
          tiktok: accountDetailsResponse?.data?.data?.tiktok,
        }
        setValues({
          ...values,
          ...currentValues
        });
        setChangedValue({
          ...changedValue,
          ...currentValues,
          email_sms_consent: accountDetailsResponse?.data?.data?.email_sms_consent,
        });
        if (accountDetailsResponse?.data?.data?.email_sms_consent === true || accountDetailsResponse?.data?.data?.email_sms_consent === false) {
          setDisclaimerAccepted(accountDetailsResponse?.data?.data?.email_sms_consent);
          setChangedValue({
            ...changedValue,
            ...currentValues,
            email_sms_consent: accountDetailsResponse?.data?.data?.email_sms_consent,
          });
        } else {
          setDisclaimerAccepted(true);
          setChangedValue({
            ...changedValue,
            ...currentValues,
            email_sms_consent: true,
          });
        }
        setAccountDetails(accountDetailsResponse?.data?.data);
        if (isUpdate) {

          dispatch(
            getUserDetails({
              userDetails: accountDetailsResponse?.data?.data,
            })
          );
        }
        setLoading(false)
      }
    } catch (err) {

    }
  };
  const handleUpdate = (item) => {
    const { name, value } = item?.target;
    handleChange(name, value);
  };

  const handleChange = (name, value) => {
    setValues({
      ...values,
      [name]: value,
    });
    setChangedValue({
      ...changedValue,
      [name]: value,
      ['countryName']: currentCountry?.name,
    })
  };

  const handleUpdateItem = (item) => {
    const { name, value } = item?.target;
    setValues({
      ...values,
      [name]: value,
    });
  }


  const validation = () => {
    let validationStatus = true;
    let errors = {};
    let nameRegex = /^[a-zA-Z ]{3,30}$/;
    const { firstName, lastName, country, phone } = values;

    if (!firstName) {
      errors.firstName = <Translate textKey={'first_name_required'} />
      validationStatus = false;
    } else if (!firstName?.match(nameRegex)) {
      errors.firstName =
        <Translate textKey={'name_validation_message'} />
      validationStatus = false;
    }

    if (!lastName) {
      errors.lastName = <Translate textKey={'last_name_required'} />
      validationStatus = false;
    } else if (!lastName?.match(nameRegex)) {
      errors.lastName =
        <Translate textKey={'name_validation_message'} />
      validationStatus = false;
    }

    if (!country) {
      errors.country = <Translate textKey={'country_required'} />
      validationStatus = false;
    } else if (country === <Translate textKey={'select_country'} />) {
      errors.country = <Translate textKey={'country_required'} />
      validationStatus = false;
    }
    try {
      if (phone && phone.trim() !== "") {

        // Ensure only a single '+' prefix
        const formattedPhone = '+' + phone.replace(/^(\++)/, '');
        const phoneNumber = parsePhoneNumber(formattedPhone);

        if (!phoneNumber.isValid()) {
          errors.phone = <Translate textKey={'phone_error_msg'} />;
          validationStatus = false;
        }
        setChangedValue({
          ...changedValue,
          phone: phoneNumber.formatInternational(),
        });
      }
    } catch (e) {
      errors.phone = <Translate textKey={'phone_error_msg'} />;
      validationStatus = false;
    }
    setErrors(errors);
    return validationStatus;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (validation() === true) {
      setValues((prev) => ({ ...prev, currentPassword: "" }));
      setPasswordModal(true);
    } else {
      toast.error(<Translate textKey={'check_the_fields'} />, {
        position: "bottom-center",
      });
    }
  };
  const updateAccountDetails = async () => {
    try {
      const response = await service.updateAccountdetails(appInfo, changedValue);
      if (response?.data?.success === true) {
        toast.success(<Translate textKey={'account_updated_message'} />, {
          position: "bottom-center",
        });
        setPasswordModal(false);
        fetchAccountDetails(true);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
  };

  const handleFileChange = (e) => {
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    if (!allowedExtensions.exec(e?.target?.files[0]?.name)) {
      toast.error(<Translate textKey={'invalid_extension_message'} />, {
        position: "bottom-center",
      });
    } else {

      const name = e?.target?.files[0]?.name;
      const files = e?.target?.files;
      setValues({
        ...values,
        file: files[0],
      });
      setProfileWill(URL.createObjectURL(files[0]))
      setProfileDirty(true);
    }
  }

  const handleProfilePictureSave = async () => {
    if (!values?.file) {
      return;
    }
    setProfileUploading(true);
    try {
      const response = await service.updateAccountdetails(appInfo, { file: values.file });
      if (response?.data?.success === true) {
        toast.success(<Translate textKey={'account_updated_message'} />, {
          position: "bottom-center",
        });
        setProfileDirty(false);
        setValues((prev) => ({ ...prev, file: null }));
        fetchAccountDetails(true);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to update profile picture", {
        position: "bottom-center",
      });
    } finally {
      setProfileUploading(false);
    }
  };

  const handleSidebarTabClick = (tabKey) => {
    const sectionMap = {
      profile: profileSectionRef,
      paymentSectionRef: paymentSectionRef,
      settings: settingsSectionRef,
    };
    setActiveSidebarTab(tabKey);
    const sectionElement = sectionMap?.[tabKey]?.current;
    if (sectionElement) {
      const headerOffset = 100;
      const targetY = sectionElement.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: Math.max(0, targetY), behavior: "smooth" });
    }
  };

  if (loading) {
    return (
      <Loading />
    )
  }
  return (
    <div className={`accountSettings ${isRTL ? "rtl" : ""}`}>
      {PasswordModal && (
        <CurrentPasswordModal
          fetchAccountDetails={fetchAccountDetails}
          updateAccountDetails={updateAccountDetails}
          values={values}
          handleUpdate={handleUpdate}
          handleUpdateItem={handleUpdateItem}
          handleChange={handleChange}
          setValues={setValues}
          setChangedValue={setChangedValue}
          setErrors={setErrors}
          errors={errors}
          setPasswordModal={setPasswordModal}
        />
      )}
      {cancelSubModal && (
        <CancelSubscriptionModal
          fetchAccountDetails={fetchAccountDetails}
          setCancelSubModal={setCancelSubModal}
          subId={accountDetails?.sub_id}
          pauseStatus={accountDetails?.pause_status}
          setPauseSubModal={setPauseSubModal}
        />
      )}
      {pauseSubModal && (
        <PauseSubscriptionModal
          fetchAccountDetails={fetchAccountDetails}
          setPauseSubModal={setPauseSubModal}
          subId={accountDetails?.sub_id}
        />
      )}
      {logoutModal && (
        <LogoutAllModal
          appInfo={appInfo}
          setLogoutModal={setLogoutModal}
          modalType={{
            type: "logoutAll",
            heading: <Translate textKey={'logout_all_text'} />,
          }}
        />
      )}

      <div className="wrapper">
        <div className="accountShell">
          <aside className="accountSidebar">
            <div className="sidebarProfileCard">
              <div className="avatarWrap">
                {profileWill ? (
                  <img src={profileWill} alt="Profile" />
                ) : accountDetails?.user_image ? (
                  <img src={accountDetails?.user_image} alt="Profile" />
                ) : (
                  <img src={require("../../../assets/Images/user_avatar.png")} alt="Avatar" />
                )}
                <label htmlFor="file" className="editAvatarButton" aria-label="Edit profile picture">
                  <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
                    <path d="M4 20h4l10-10-4-4L4 16v4z" fill="none" stroke="currentColor" strokeWidth="1.8" />
                    <path d="M12.5 6.5l4 4" fill="none" stroke="currentColor" strokeWidth="1.8" />
                  </svg>
                </label>
              </div>
              <p className="profileMail">{values?.email || ""}</p>
              <input type="file" id="file" accept="image/*" onChange={(e) => handleFileChange(e)} />
              {profileDirty && (
                <button
                  type="button"
                  className="savePhotoButton"
                  onClick={handleProfilePictureSave}
                >
                  {profileUploading ? "Saving..." : "Save photo"}
                </button>
              )}
            </div>

            <nav className="sidebarNav">
              <button
                type="button"
                className={`sidebarTab ${activeSidebarTab === "profile" ? "active" : ""}`}
                onClick={() => handleSidebarTabClick("profile")}
              >
                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="6" r="4" stroke="#ffffff" stroke-width="1.5"></circle> <path d="M19.9975 18C20 17.8358 20 17.669 20 17.5C20 15.0147 16.4183 13 12 13C7.58172 13 4 15.0147 4 17.5C4 19.9853 4 22 12 22C14.231 22 15.8398 21.8433 17 21.5634" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>
                Profile
              </button>
              <button
                type="button"
                className={`sidebarTab ${activeSidebarTab === "paymentSectionRef" ? "active" : ""}`}
                onClick={() => handleSidebarTabClick("paymentSectionRef")}
              >
                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect x="3" y="6" width="18" height="13" rx="2" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></rect> <path d="M3 10H20.5" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7 15H9" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                Payment
              </button>
              <button
                type="button"
                className={`sidebarTab ${activeSidebarTab === "settings" ? "active" : ""}`}
                onClick={() => handleSidebarTabClick("settings")}
              >
                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="12" r="3" stroke="#ffffff" stroke-width="1.5"></circle> <path d="M3.66122 10.6392C4.13377 10.9361 4.43782 11.4419 4.43782 11.9999C4.43781 12.558 4.13376 13.0638 3.66122 13.3607C3.33966 13.5627 3.13248 13.7242 2.98508 13.9163C2.66217 14.3372 2.51966 14.869 2.5889 15.3949C2.64082 15.7893 2.87379 16.1928 3.33973 16.9999C3.80568 17.8069 4.03865 18.2104 4.35426 18.4526C4.77508 18.7755 5.30694 18.918 5.83284 18.8488C6.07287 18.8172 6.31628 18.7185 6.65196 18.5411C7.14544 18.2803 7.73558 18.2699 8.21895 18.549C8.70227 18.8281 8.98827 19.3443 9.00912 19.902C9.02332 20.2815 9.05958 20.5417 9.15224 20.7654C9.35523 21.2554 9.74458 21.6448 10.2346 21.8478C10.6022 22 11.0681 22 12 22C12.9319 22 13.3978 22 13.7654 21.8478C14.2554 21.6448 14.6448 21.2554 14.8478 20.7654C14.9404 20.5417 14.9767 20.2815 14.9909 19.9021C15.0117 19.3443 15.2977 18.8281 15.7811 18.549C16.2644 18.27 16.8545 18.2804 17.3479 18.5412C17.6837 18.7186 17.9271 18.8173 18.1671 18.8489C18.693 18.9182 19.2249 18.7756 19.6457 18.4527C19.9613 18.2106 20.1943 17.807 20.6603 17C20.8677 16.6407 21.029 16.3614 21.1486 16.1272M20.3387 13.3608C19.8662 13.0639 19.5622 12.5581 19.5621 12.0001C19.5621 11.442 19.8662 10.9361 20.3387 10.6392C20.6603 10.4372 20.8674 10.2757 21.0148 10.0836C21.3377 9.66278 21.4802 9.13092 21.411 8.60502C21.3591 8.2106 21.1261 7.80708 20.6601 7.00005C20.1942 6.19301 19.9612 5.7895 19.6456 5.54732C19.2248 5.22441 18.6929 5.0819 18.167 5.15113C17.927 5.18274 17.6836 5.2814 17.3479 5.45883C16.8544 5.71964 16.2643 5.73004 15.781 5.45096C15.2977 5.1719 15.0117 4.6557 14.9909 4.09803C14.9767 3.71852 14.9404 3.45835 14.8478 3.23463C14.6448 2.74458 14.2554 2.35523 13.7654 2.15224C13.3978 2 12.9319 2 12 2C11.0681 2 10.6022 2 10.2346 2.15224C9.74458 2.35523 9.35523 2.74458 9.15224 3.23463C9.05958 3.45833 9.02332 3.71848 9.00912 4.09794C8.98826 4.65566 8.70225 5.17191 8.21891 5.45096C7.73557 5.73002 7.14548 5.71959 6.65205 5.4588C6.31633 5.28136 6.0729 5.18269 5.83285 5.15108C5.30695 5.08185 4.77509 5.22436 4.35427 5.54727C4.03866 5.78945 3.80569 6.19297 3.33974 7C3.13231 7.35929 2.97105 7.63859 2.85138 7.87273" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>
                Settings
              </button>
            </nav>
          </aside>

          <div className="accountMain">
            <section className="accountCard" ref={profileSectionRef}>
              <h4 className="sectionHeading">PROFILE INFORMATION</h4>
              <div className="profileFormCard">
                <div className="formSection">
                  <form
                    className={`${projectInfo?.projectConfig?.pubid === 50147 ? 'template-11-font' : (projectInfo?.projectConfig?.pubid === 50167 && (window.location.hostname || '').includes('sparktv.gizmott.com')) ? 'template-12-font' : ''}`}
                    onSubmit={onSubmitHandler}
                  >
                    <div className="half">
                      <div className="fname">
                        <label htmlFor="#fname"><Translate textKey={'first_name'} /></label>
                        <input
                          name="firstName"
                          value={values?.firstName || ""}
                          type="text"
                          id="fname"
                          onChange={(item) => handleUpdate(item)}
                        />
                        {errors?.firstName && (
                          <span className="error text-danger">
                            {errors?.firstName}
                          </span>
                        )}
                      </div>
                      <div className="lname">
                        <label htmlFor="#lname"><Translate textKey={'last_name'} /></label>
                        <input
                          name="lastName"
                          type="text"
                          id="lname"
                          value={values?.lastName || ""}
                          onChange={(item) => handleUpdate(item)}
                        />
                        {errors?.lastName && (
                          <span className="error text-danger">
                            {errors?.lastName}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="half">
                      <div className="email">
                        <label htmlFor="email"><Translate textKey={'email'} /></label>
                        <input
                          name="email"
                          value={values?.email || ""}
                          disabled
                          type="email"
                          id="email"
                          onChange={(item) => handleUpdate(item)}
                        />
                      </div>

                      <div className="phone fifty">
                        <label htmlFor="phone"><Translate textKey={'phone'} /></label>
                        <PhoneInput
                          enableSearch={true}
                          dropdownStyle={{
                            height: '200px',
                            textAlign: 'justify',
                          }}
                          className="phoneInput"
                          country={'us'}
                          value={values?.phone || ""}
                          onChange={phone => handleChange('phone', phone)}
                          inputProps={{
                            name: 'phone',
                            id: 'phone',
                            required: true,
                          }}
                          inputStyle={{
                            width: '100%',
                            padding: '0% 7%',
                            height: '60px',
                          }}
                          containerClass="phone-input-responsive"
                          name="phone"
                          type="tel"
                        />
                        {errors?.phone && <span className="error">{errors?.phone}</span>}
                      </div>
                    </div>

                    {appInfo?.projectDetails?.projectConfig?.pubid === 50124 ? <>
                      <div className="half">
                        <div className="klaviyo fifty">
                          <label htmlFor="email">Shipping Address Line 1</label>
                          <input
                            type="text"
                            name="address1"
                            value={values?.address1 || ""}
                            id="address1"
                            onChange={handleUpdate}
                          />
                        </div>
                        <div className="klaviyo fifty">
                          <label htmlFor="email">Shipping Address Line 2</label>
                          <input
                            type="text"
                            name="address2"
                            value={values?.address2 || ""}
                            id="address2"
                            onChange={handleUpdate}
                          />
                        </div>
                      </div>
                      <div className="half">
                        <div className="fifty">
                          <label htmlFor="#fname">City</label>
                          <input
                            name="city"
                            value={values?.city || ""}
                            type="text"
                            id="city"
                            onChange={(item) => handleUpdate(item)}
                          />
                        </div>
                        <div className="fifty">
                          <label htmlFor="#lname">State</label>
                          <input
                            name="state"
                            type="text"
                            id="state"
                            value={values?.state || ""}
                            onChange={(item) => handleUpdate(item)}
                          />
                        </div>
                      </div>
                      <div className="half">
                        <div className="country">
                          <label htmlFor="text"><Translate textKey={'country'} /></label>
                          <select
                            name="country"
                            id="country"
                            onChange={(item) => handleUpdate(item)}
                          >
                            <option value={currentCountry?.value} >{currentCountry?.name}</option>
                            {countryListOption}
                          </select>
                          {errors?.country && (
                            <span className="error text-danger">
                              {errors?.country}
                            </span>
                          )}
                        </div>
                        <div className="fifty">
                          <label htmlFor="#lname">Postal Code</label>
                          <input
                            name="postal_code"
                            type="text"
                            id="postal_code"
                            value={values?.postal_code || ""}
                            onChange={(item) => handleUpdate(item)}
                          />
                        </div>
                      </div>
                      <div className="half">
                        <div className="fifty">
                          <label htmlFor="#lname">Which Celebrity Did You Sign Up For?</label>
                          <input
                            name="celebrity_source"
                            type="text"
                            id="celebrity_source"
                            value={values?.celebrity_source || ""}
                            onChange={(item) => handleUpdate(item)}
                          />
                        </div>
                        <div className="fifty">
                          <label htmlFor="#lname">Favorite Celebrity Ever?</label>
                          <input
                            name="favorite_celebrity"
                            type="text"
                            id="favorite_celebrity"
                            value={values?.favorite_celebrity || ""}
                            onChange={(item) => handleUpdate(item)}
                          />
                        </div>
                      </div>
                      <div className="half">
                        <div className="fifty">
                          <label htmlFor="#lname">Birthday</label>
                          <input
                            name="birthday"
                            type="date"
                            id="birthday"
                            value={values?.birthday || ""}
                            onChange={(item) => handleUpdate(item)}
                          />
                        </div>
                        <div className="fifty">
                          <label htmlFor="instagram">Instagram Handle</label>
                          <input
                            name="instagram"
                            type="text"
                            id="instagram"
                            value={values?.instagram || ""}
                            onChange={handleUpdate}
                            placeholder="@yourinstagramhandle"
                          />
                        </div>
                      </div>
                      <div className="half">
                        <div className="fifty">
                          <label htmlFor="youtube">YouTube Handle</label>
                          <input
                            name="youtube"
                            type="text"
                            id="youtube"
                            value={values?.youtube || ""}
                            onChange={handleUpdate}
                            placeholder="@youryoutubehandle"
                          />
                        </div>
                        <div className="fifty">
                          <label htmlFor="facebook">Facebook Handle</label>
                          <input
                            name="facebook"
                            type="text"
                            id="facebook"
                            value={values?.facebook || ""}
                            onChange={handleUpdate}
                            placeholder="@yourfacebookhandle"
                          />
                        </div>
                      </div>
                      <div className="half">
                        <div className="fifty">
                          <label htmlFor="tiktok">TikTok Handle</label>
                          <input
                            name="tiktok"
                            type="text"
                            id="tiktok"
                            value={values?.tiktok || ""}
                            onChange={handleUpdate}
                            placeholder="@yourtiktokhandle"
                          />
                        </div>
                      </div>
                    </> : <div className="half">
                      <div className="country">
                        <label htmlFor="text"><Translate textKey={'country'} /></label>
                        <select
                          name="country"
                          id="country"
                          onChange={(item) => handleUpdate(item)}
                        >
                          <option value={currentCountry?.value} >{currentCountry?.name}</option>
                          {countryListOption}
                        </select>
                        {errors?.country && (
                          <span className="error text-danger">
                            {errors?.country}
                          </span>
                        )}
                      </div>
                    </div>}

                    <div className="full accountLinksRow">
                      {accountDetails?.password_exists === true ? (
                        <Link to="/change-password">
                          <span className="cpassword"><Translate textKey={'change_password'} /></span>
                        </Link>
                      ) : (
                        <Link to="/set-password" state={accountDetails}>
                          <span className="cpassword"><Translate textKey={'set_password'} /></span>
                        </Link>
                      )}
                    </div>

                    {appInfo?.projectDetails?.projectConfig?.pubid === 50124 && <div className="disclaimer-section">
                      <label>
                        <input
                          type="checkbox"
                          checked={disclaimerAccepted}
                          onChange={e => {
                            setDisclaimerAccepted(e.target.checked);
                            setChangedValue({
                              ...changedValue,
                              phone: values?.phone ? values.phone.split('+').join('') : '',
                              email_sms_consent: e.target.checked ? true : false,
                              email: values?.email || '',
                            });
                          }}
                        />
                        <span>
                          I acknowledge that by selecting this option, I am consenting to receive promotional communications via Email and SMS. I understand that I may opt out at any time.
                        </span>
                      </label>
                    </div>}

                    <div className="formActions">
                      <button type="submit" className={`primarySaveButton ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                        <Translate textKey={'save_changes'} />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </section>

            <section className="accountCard" ref={paymentSectionRef}>
              <h4 className="sectionHeading">MEMBERSHIP & WALLET</h4>
              <div className="membershipCard">
                {(accountDetails?.mode_of_payment === "Vizio" || accountDetails?.mode_of_payment === "vizio") && (
                  <div className="vizioBanner">
                    <Translate textKey={'vizio_subscription_message'} />
                    <span onClick={() => window.open('https://www.vizio.com/en/vizio-account', '_blank')}>https://www.vizio.com/en/vizio-account</span>.
                  </div>
                )}

                <div className="membershipRow">
                  <div>
                    <h5>CURRENT PLAN</h5>
                    <p className="mainValue">{accountDetails?.subscription_name || "No active plan"}</p>
                  </div>
                  <span className={`statusBadge ${accountDetails?.cancel_status === false && accountDetails?.sub_id ? 'active' : 'inactive'}`}>
                    {accountDetails?.cancel_status === false && accountDetails?.sub_id ? "ACTIVE" : "INACTIVE"}
                  </span>
                </div>

                <div className="membershipRow">
                  <div>
                    <h5>COIN BALANCE</h5>
                    <p className="mainValue coinValue">
                      {userCoins?.token_symbol ? (
                        <img
                          src={userCoins.token_symbol}
                          alt={userCoins?.token_name || "Token"}
                          width="22"
                          height="22"
                        />
                      ) : null}
                      {userCoins?.current_balance || 0} coins
                    </p>
                  </div>
                  <button type="button" className="topUpPill" onClick={() => navigate("/bundles/purchase")}>
                    <Translate textKey={'top_up'} />
                  </button>
                </div>

                <div className="membershipActions">
                  <Link to="billing-activity" className="secondaryPill"><Translate textKey={'transaction_details'} /></Link>
                  {accountDetails?.cancel_status === true ? (
                    <Link to="/subscription" className="secondaryPill"><Translate textKey={'subscribe'} /></Link>
                  ) : (
                    accountDetails?.mode_of_payment !== 'giftcard' && (accountDetails?.subscription_type === 3 || accountDetails?.subscription_type === 4) && (
                      <button type="button" className="secondaryPill" onClick={() => setCancelSubModal(true)}>
                        <Translate textKey={'cancel_membership'} />
                      </button>
                    )
                  )}
                  {[50148, 50124].includes(appInfo?.projectDetails?.projectConfig?.pubid) && accountDetails?.sub_id && accountDetails?.cancel_status === false && (
                    <button
                      type="button"
                      className="secondaryPill"
                      onClick={() => accountDetails?.pause_status === false ? setPauseSubModal(true) : handleResume()}
                    >
                      {accountDetails?.pause_status === false ? <Translate textKey={'pause_subscription'} /> : <Translate textKey={'resume_subscription'} />}
                    </button>
                  )}
                  {projectInfo?.projectConfig?.config?.CHANGE_PLAN_REQUIRED == "true" && accountDetails?.change_plan_required === true && (accountDetails?.subscription_type === 3 || accountDetails?.subscription_type === 4) && (
                    projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' ? (
                      <Link to="/checkout" state={{ type: "upgrade", subId: accountDetails?.sub_id }} className="secondaryPill">
                        <Translate textKey={'change_plan_caps'} />
                      </Link>
                    ) : (
                      <Link to="/subscription" state={{ type: "upgrade", subId: accountDetails?.sub_id }} className="secondaryPill">
                        <Translate textKey={'change_plan_caps'} />
                      </Link>
                    )
                  )}
                  {projectInfo?.projectConfig?.config?.GIFT_REQUIRED === "true" && !(accountDetails?.sub_id && accountDetails?.mode_of_payment !== "Vizio" && accountDetails?.mode_of_payment !== "vizio") && (
                    <Link to="gift-activity" className="secondaryPill">
                      <Translate textKey={'gift_details'} />
                    </Link>
                  )}
                </div>
              </div>
            </section>

            <section className="accountCard" ref={settingsSectionRef}>
              <h4 className="sectionHeading">SETTINGS</h4>
              <div className="settingsRows">
                <Link to="streaming-activity" className="settingsRow">
                  <span><Translate textKey={'recent_device_streaming_activity'} /></span>
                  <span className="arrow">&gt;</span>
                </Link>
                <button type="button" className="settingsRow" onClick={() => setLogoutModal(true)}>
                  <span><Translate textKey={'sign_out_from_all_devices'} /></span>
                  <span className="arrow">&gt;</span>
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewAccountSettings;
